var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    attrs: {
      "id": "q-app"
    }
  }, [_vm.appStarted ? _c('router-view') : _c('app-loader', {
    on: {
      "open": function open($event) {
        return _vm.start(true);
      }
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };